export default __webpack_public_path__ + "240e69d5357ca5a933c37784ce76ab8c.svg";